import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import DeliverableService from "../../../features/DeliverableView/services/DeliverableService";
import {
  COA_NAME_LABEL,
  DELIVERABLE_NAME_LABEL,
  FILTER_CREATED_BY_LABEL,
  FILTER_CREATED_ON_LABEL,
  GLOBAL_TEMPLATE_LABEL,
  TOAST_DEFAULT_ERROR_MESSAGE,
} from "../../utils/CommonConstants";
import {
  Image,
  StyledProjectSection,
} from "./DeliverableDetailsComponent.styles";
import {
  DeliverableMenuDetailsResponse,
  Tag,
} from "./DeliverableDetailsComponent.types";
import { Divider, message, Breadcrumb } from "antd";
import { Container } from "../../../shared/base-components/Layouts/Container/Container.styles";

export const ProjectDetailsSection: React.FC = () => {
  const projectService: DeliverableService = new DeliverableService();
  const [deliverableDetails, setDeliverableDetails] =
    useState<DeliverableMenuDetailsResponse | null>(null);
  const { deliverableId } = useParams<{ deliverableId: string }>();
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliverableId]);
  const fetchData = async (): Promise<void> => {
    try {
      const response =
        await projectService.getDeliverableDetailsById<DeliverableMenuDetailsResponse>(
          Number(deliverableId)
        );
      setDeliverableDetails(response);
    } catch (error) {
      message.error(TOAST_DEFAULT_ERROR_MESSAGE);
    }
  };

  return (
    <StyledProjectSection>
      <Breadcrumb
          className="breadCrump"
          style={{marginBottom: "10px", marginLeft: "1.3rem", marginTop: "15px"}}
          items={[
            {
              title: "Deliverable",
            },
            {
              title: "Deliverable List",
            },
            {
              title: "Deliverable Dashboard",
            },
          ]}
        />
      <Container className="project-details">
        <div className="projects">
          <div className="item">
            <span className="title">{DELIVERABLE_NAME_LABEL}</span>
            <span className="details">{deliverableDetails?.name}</span>
          </div>

          <div className="item">
            <span className="title">{GLOBAL_TEMPLATE_LABEL}</span>
            <span className="details">
              {deliverableDetails?.ruleEngineTemplateName}
            </span>
          </div>

          {deliverableDetails?.coaTemplateName && (
            <div className="item">
              <span className="title">{COA_NAME_LABEL}</span>
              <span className="details">
                {deliverableDetails?.coaTemplateName}
              </span>
            </div>
          )}

          <div className="item">
            <span className="title">{FILTER_CREATED_BY_LABEL}</span>
            <span className="details">
              {deliverableDetails?.createdUserName}
            </span>
          </div>

          <div className="item">
            <span className="title">{FILTER_CREATED_ON_LABEL}</span>
            <span className="details">{deliverableDetails?.createdOn}</span>
          </div>

          {deliverableDetails?.tag.length ? <Divider /> : ""}

          {deliverableDetails?.tag?.map((tagItem: Tag) => (
            <div key={tagItem.id} className="item">
              <span className="title">{tagItem.name}</span>
              <span className="details">{tagItem.value}</span>
            </div>
          ))}
        </div>
        <Image />
      </Container>
    </StyledProjectSection>
  );
};
